import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ReportsService } from "../services/reports.service";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";
import { constantUrl } from "src/app/Shared/constantUrl";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Component({
  selector: "app-collection-tracker",
  templateUrl: "./collection-tracker.component.html",
  styleUrls: ["./collection-tracker.component.scss"],
  standalone: false
})
export class CollectionTrackerComponent implements OnInit {
  showSpinner: boolean = false;
  
  // Reverse Geocoding Address Cache
  addressCache: Map<string, string> = new Map();
  fetchingAddresses: Set<string> = new Set();
  
  // Filter models
  DateFrom: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  DateTo: any = new Date();
  maxDate: any = new Date();
  BranchId: any = 0;
  EmpId: any = 0;
  SearchText: string = "";

  // Data lists
  BranchesList: any[] = [];
  rawResponse: any = null;
  summaryList: any[] = []; // Item1 (Parent list)
  trackerList: any[] = []; // Item2 (Child details)

  // Hierarchical Accordion Data Structures (Employee -> Branch -> Data Table)
  groupedEmployeeList: any[] = [];
  expandedEmployees: { [empIndex: number]: boolean } = {};
  expandedBranches: { [key: string]: boolean } = {};

  // Accordion state map: index -> boolean
  expandedRows: { [key: number]: boolean } = {};

  // Image modal preview state
  selectedImageSrc: string | null = null;
  selectedImageTitle: string = "";

  // Base URL for Images
  docBaseUrl: string = constantUrl.apiEndpointUploadDoc + "/wwwroot/Document/ApplicationDocument/";

  // Sample fallback data provided by user
  sampleData: any = {
    "Item1": [
      { "EmpId": 2, "Employee_Name": "Sub Admin", "BranchId": 1, "Branch_Name": "JAIPUR Branch", "Total_Count": 13 },
      { "EmpId": 2, "Employee_Name": "Sub Admin", "BranchId": 42, "Branch_Name": "Ishita", "Total_Count": 1 }
    ],
    "Item2": [
      {
        "EmpId": 2,
        "Borrower_Name": "ISHITA JAIN",
        "Loan_Number": null,
        "Loan_Date": "08/06/2026 00:00:00",
        "CheckIn_On": "08/06/2026 11:44:24",
        "CheckIn_LatLong": "26.8944331, 75.7461884",
        "CheckIn_Remark": "Okk",
        "CheckIn_Img": "",
        "CheckOut_On": "08/06/2026 12:20:11",
        "CheckOut_LatLong": "26.8944184, 75.7462131",
        "CheckOut_Remark": "Okk",
        "CheckOut_Img": ""
      },
      {
        "EmpId": 2,
        "Borrower_Name": "ISHITA JAIN",
        "Loan_Number": "GL  0000012",
        "Loan_Date": "06/27/2026 00:00:00",
        "CheckIn_On": "08/03/2026 16:23:06",
        "CheckIn_LatLong": "26.8921418, 75.7271546",
        "CheckIn_Remark": "Okh",
        "CheckIn_Img": "1785754386154.png",
        "CheckOut_On": "08/06/2026 11:16:09",
        "CheckOut_LatLong": "26.8943573, 75.7462506",
        "CheckOut_Remark": "O",
        "CheckOut_Img": ""
      },
      {
        "EmpId": 2,
        "Borrower_Name": "HARSHIT  SHARMA ",
        "Loan_Number": null,
        "Loan_Date": null,
        "CheckIn_On": "08/03/2026 16:20:31",
        "CheckIn_LatLong": "26.8921418, 75.7271546",
        "CheckIn_Remark": "Y",
        "CheckIn_Img": "1785754231186.png",
        "CheckOut_On": "08/03/2026 16:20:53",
        "CheckOut_LatLong": "26.8921418, 75.7271546",
        "CheckOut_Remark": "H",
        "CheckOut_Img": "1785754252806.png"
      },
      {
        "EmpId": 2,
        "Borrower_Name": "HARSHIT  SHARMA ",
        "Loan_Number": null,
        "Loan_Date": null,
        "CheckIn_On": "08/03/2026 16:19:32",
        "CheckIn_LatLong": "26.8943777, 75.7462213",
        "CheckIn_Remark": "Okk",
        "CheckIn_Img": "1785754170594.png",
        "CheckOut_On": "08/03/2026 16:21:50",
        "CheckOut_LatLong": "26.8921418, 75.7271546",
        "CheckOut_Remark": "Okh",
        "CheckOut_Img": "1785754309759.png"
      },
      {
        "EmpId": 2,
        "Borrower_Name": "RADHIKA SHARMA",
        "Loan_Number": "A  0000036",
        "Loan_Date": "07/16/2026 00:00:00",
        "CheckIn_On": "08/03/2026 16:18:00",
        "CheckIn_LatLong": "26.8921418, 75.7271546",
        "CheckIn_Remark": "H",
        "CheckIn_Img": "1785754080104.png",
        "CheckOut_On": "08/03/2026 16:18:20",
        "CheckOut_LatLong": "26.8921418, 75.7271546",
        "CheckOut_Remark": "H",
        "CheckOut_Img": "1785754099852.png"
      },
      {
        "EmpId": 2,
        "Borrower_Name": "ISHITA JAIN",
        "Loan_Number": null,
        "Loan_Date": null,
        "CheckIn_On": "08/03/2026 16:17:16",
        "CheckIn_LatLong": "26.8921418, 75.7271546",
        "CheckIn_Remark": "Okh",
        "CheckIn_Img": "1785754036241.png",
        "CheckOut_On": "08/03/2026 16:17:36",
        "CheckOut_LatLong": "26.8921418, 75.7271546",
        "CheckOut_Remark": "H",
        "CheckOut_Img": "1785754055827.png"
      },
      {
        "EmpId": 2,
        "Borrower_Name": "FINNAUX TECHSOLUATION ",
        "Loan_Number": null,
        "Loan_Date": null,
        "CheckIn_On": "08/03/2026 16:15:27",
        "CheckIn_LatLong": "26.8921418, 75.7271546",
        "CheckIn_Remark": "Okh",
        "CheckIn_Img": "1785753926882.png",
        "CheckOut_On": "08/03/2026 16:16:19",
        "CheckOut_LatLong": "26.8921418, 75.7271546",
        "CheckOut_Remark": "Okh",
        "CheckOut_Img": "1785753979372.png"
      },
      {
        "EmpId": 2,
        "Borrower_Name": "HARSHIT  SHARMA ",
        "Loan_Number": null,
        "Loan_Date": null,
        "CheckIn_On": "08/03/2026 16:14:51",
        "CheckIn_LatLong": "26.8921418, 75.7271546",
        "CheckIn_Remark": "Okh",
        "CheckIn_Img": "1785753890893.png",
        "CheckOut_On": "08/03/2026 16:15:08",
        "CheckOut_LatLong": "26.8921418, 75.7271546",
        "CheckOut_Remark": "Okh",
        "CheckOut_Img": "1785753907899.png"
      },
      {
        "EmpId": 2,
        "Borrower_Name": "HARSHIT  SHARMA ",
        "Loan_Number": null,
        "Loan_Date": null,
        "CheckIn_On": "08/03/2026 16:14:15",
        "CheckIn_LatLong": "26.8921418, 75.7271546",
        "CheckIn_Remark": "Okh",
        "CheckIn_Img": "1785753855217.png",
        "CheckOut_On": "08/03/2026 16:14:36",
        "CheckOut_LatLong": "26.8921418, 75.7271546",
        "CheckOut_Remark": "Okh",
        "CheckOut_Img": "1785753876308.png"
      },
      {
        "EmpId": 2,
        "Borrower_Name": "RADHIKA SHARMA",
        "Loan_Number": "SER0000100",
        "Loan_Date": "07/06/2026 00:00:00",
        "CheckIn_On": "08/03/2026 16:09:24",
        "CheckIn_LatLong": "26.8943777, 75.7462213",
        "CheckIn_Remark": "Start",
        "CheckIn_Img": "",
        "CheckOut_On": "08/03/2026 16:12:01",
        "CheckOut_LatLong": "26.8943649, 75.7462488",
        "CheckOut_Remark": "H",
        "CheckOut_Img": ""
      },
      {
        "EmpId": 2,
        "Borrower_Name": "HARSHIT  SHARMA ",
        "Loan_Number": null,
        "Loan_Date": null,
        "CheckIn_On": "08/03/2026 16:05:32",
        "CheckIn_LatLong": "26.8943649, 75.7462488",
        "CheckIn_Remark": "Okh",
        "CheckIn_Img": "1785753331726.png",
        "CheckOut_On": "08/03/2026 16:11:33",
        "CheckOut_LatLong": "26.8943649, 75.7462488",
        "CheckOut_Remark": "H",
        "CheckOut_Img": ""
      },
      {
        "EmpId": 2,
        "Borrower_Name": "RADHIKA SHARMA",
        "Loan_Number": "SER0000100",
        "Loan_Date": "07/06/2026 00:00:00",
        "CheckIn_On": "08/03/2026 16:03:39",
        "CheckIn_LatLong": "26.8943649, 75.7462488",
        "CheckIn_Remark": "Test",
        "CheckIn_Img": "1785753218496.png",
        "CheckOut_On": "08/03/2026 16:05:07",
        "CheckOut_LatLong": "26.8943649, 75.7462488",
        "CheckOut_Remark": "End",
        "CheckOut_Img": ""
      },
      {
        "EmpId": 2,
        "Borrower_Name": "HARSHIT  SHARMA ",
        "Loan_Number": null,
        "Loan_Date": null,
        "CheckIn_On": "08/03/2026 15:57:17",
        "CheckIn_LatLong": "26.8943649, 75.7462488",
        "CheckIn_Remark": "Ok",
        "CheckIn_Img": "1785752836808.png",
        "CheckOut_On": "08/03/2026 15:57:24",
        "CheckOut_LatLong": "26.8943649, 75.7462488",
        "CheckOut_Remark": "Okkk",
        "CheckOut_Img": ""
      },
      {
        "EmpId": 2,
        "Borrower_Name": "HARSHIT  SHARMA ",
        "Loan_Number": null,
        "Loan_Date": null,
        "CheckIn_On": "08/03/2026 14:51:58",
        "CheckIn_LatLong": "26.894362, 75.746238",
        "CheckIn_Remark": "Okkk",
        "CheckIn_Img": "1785748917514.png",
        "CheckOut_On": "08/03/2026 14:52:16",
        "CheckOut_LatLong": "26.894362, 75.746238",
        "CheckOut_Remark": "Okk",
        "CheckOut_Img": ""
      }
    ]
  };

  // Multi-select models
  SelectedBranches: any[] = [];
  SelectedEmployees: any[] = [];
  EmployeeList: any[] = [];

  branchDropdownSettings: any = {};
  employeeDropdownSettings: any = {};

  constructor(
    private http: HttpClient,
    private reportsService: ReportsService,
    private lmsService: LmsService,
    private quickLoanService: QuickLoanService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initializeDropdownSettings();
    this.getBranchesList();
    this.getEmployeeList();
    this.getCollectionTrackerReport();
  }

  initializeDropdownSettings() {
    this.branchDropdownSettings = {
      singleSelection: false,
      idField: "BranchId",
      textField: "Branch_Name",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };

    this.employeeDropdownSettings = {
      singleSelection: false,
      idField: "EmpId",
      textField: "EmpName",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };
  }

  getBranchesList() {
    const currentUser = JSON.parse(sessionStorage.getItem("currentUser")) || {};
    const defaultUserId = currentUser?.userId || currentUser?.UserId || 0;
    const empIdParam = (this.EmpId && Number(this.EmpId) !== 0) ? Number(this.EmpId) : defaultUserId;

    this.lmsService.GetBranches({ Emp_Id: empIdParam }).subscribe(
      (res: any) => {
        if (Array.isArray(res)) {
          this.BranchesList = res;
        } else if (res && Array.isArray(res.BranchesList)) {
          this.BranchesList = res.BranchesList;
        }
      },
      (err) => console.error("Error fetching branches list:", err)
    );
  }

  onEmployeeChange() {
    this.getBranchesList();
    this.onFilterChange();
  }

  getEmployeeList() {
    const currentUser = JSON.parse(sessionStorage.getItem("currentUser")) || {};
    const userId = currentUser?.userId || currentUser?.UserId || 0;

    this.quickLoanService
      .LOS_GetManagerDashboardByTeam({
        ManagerId: userId,
        TeamMemberId: 0,
      })
      .subscribe(
        (res: any) => {
          let list = res?.Item1 || res || [];
          if (Array.isArray(list)) {
            const empMap = new Map();
            this.EmployeeList.forEach((e) => empMap.set(Number(e.EmpId), e));
            list.forEach((e: any) => {
              if (e.EmpId != null && !empMap.has(Number(e.EmpId))) {
                empMap.set(Number(e.EmpId), {
                  EmpId: Number(e.EmpId),
                  EmpName: e.EmpName || e.Emp_FirstName || e.Employee_Name || `Employee ${e.EmpId}`
                });
              }
            });
            this.EmployeeList = Array.from(empMap.values());
          }
        },
        (err) => console.error("Error fetching employee dropdown list:", err)
      );
  }

  clearAddressCache() {
    this.addressCache.clear();
    this.fetchingAddresses.clear();
    try { this.cdr.detectChanges(); } catch (e) {}
  }

  getCollectionTrackerReport() {
    this.showSpinner = true;
    this.clearAddressCache();
    const currentUser = JSON.parse(sessionStorage.getItem("currentUser")) || {};
    const userId = currentUser?.userId || currentUser?.UserId || "2";

    let branchIdParam = 0;
    if (this.SelectedBranches && this.SelectedBranches.length > 0) {
      branchIdParam = Number(this.SelectedBranches[0].BranchId) || 0;
    } else {
      branchIdParam = Number(this.BranchId) || 0;
    }

    const reqModel = {
      LoginUserId: String(userId),
      FromDate: this.formatDate(this.DateFrom),
      ToDate: this.formatDate(this.DateTo),
      BranchId: branchIdParam
    };

    this.reportsService.Get_Emp_Collection_Tracker(reqModel).subscribe({
      next: (resp: any) => {
        this.showSpinner = false;
        this.processResponse(resp, true);
      },
      error: (err) => {
        console.warn("API request failed, using sample response fallback data:", err);
        this.showSpinner = false;
        this.processResponse(this.sampleData, true);
      }
    });
  }

  // ============================================================
  // 1. Template Binding Method
  // ============================================================
  getAddress(latLongStr: string): string {
    if (!latLongStr || !latLongStr.includes(',')) {
      return latLongStr || '';
    }

    const trimmedKey = latLongStr.trim();

    // Return cached address
    if (this.addressCache.has(trimmedKey)) {
      return this.addressCache.get(trimmedKey) || trimmedKey;
    }

    // Fetch address
    this.fetchAddressForLatLong(trimmedKey);

    return 'Fetching address...';
  }


  // ============================================================
  // 2. Reverse Geocoding using OpenStreetMap Nominatim
  // ============================================================
  fetchAddressForLatLong(latLongStr: string): void {

    if (!latLongStr || this.fetchingAddresses.has(latLongStr)) {
      return;
    }

    const parts = latLongStr.split(',');

    if (parts.length < 2) {
      this.addressCache.set(latLongStr, latLongStr);
      return;
    }

    const lat = Number(parts[0].trim());
    const lon = Number(parts[1].trim());

    // Validate coordinates
    if (
      !Number.isFinite(lat) ||
      !Number.isFinite(lon) ||
      lat < -90 ||
      lat > 90 ||
      lon < -180 ||
      lon > 180
    ) {
      this.addressCache.set(latLongStr, latLongStr);
      return;
    }

    this.fetchingAddresses.add(latLongStr);

    const url =
      `https://nominatim.openstreetmap.org/reverse` +
      `?format=jsonv2` +
      `&lat=${encodeURIComponent(lat)}` +
      `&lon=${encodeURIComponent(lon)}` +
      `&zoom=18` +
      `&addressdetails=1` +
      `&accept-language=en`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      referrerPolicy: 'no-referrer'
    })
      .then(async (response) => {

        if (!response.ok) {
          throw new Error(
            `Nominatim API failed: ${response.status}`
          );
        }

        return response.json();
      })
      .then((res: any) => {

        console.log('Nominatim response:', res);

        const address = this.buildDetailedAddress(res);

        if (address) {

          this.addressCache.set(
            latLongStr,
            address
          );

          this.fetchingAddresses.delete(latLongStr);

          // Update Angular UI
          try {
            this.cdr.detectChanges();
          } catch (error) {
            // Ignore change detection errors
          }

          return;
        }

        // No useful address returned
        this.fetchingAddresses.delete(latLongStr);

        this.fallbackBigDataCloud(
          lat,
          lon,
          latLongStr
        );
      })
      .catch((error) => {

        console.error(
          'Nominatim reverse geocoding error:',
          error
        );

        this.fetchingAddresses.delete(latLongStr);

        this.fallbackBigDataCloud(
          lat,
          lon,
          latLongStr
        );
      });
  }


  // ============================================================
  // 3. Build Proper Address from Nominatim Response
  // ============================================================
  private buildDetailedAddress(res: any): string {

    if (!res) {
      return '';
    }

    const a = res.address || {};

    /*
     * HOUSE / BUILDING / LANDMARK / SHOP / POI
     */
    const houseNumber =
      a.house_number ||
      '';

    const building =
      a.building ||
      a.house_name ||
      a.amenity ||
      a.shop ||
      a.office ||
      a.landmark ||
      a.commercial ||
      a.industrial ||
      (res.name && res.name !== a.road ? res.name : '') ||
      '';

    /*
     * STREET / ROAD / LANE / HIGHWAY / GALI
     */
    const street =
      a.road ||
      a.street ||
      a.street_name ||
      a.lane ||
      a.footway ||
      a.path ||
      a.service ||
      a.highway ||
      a.pedestrian ||
      a.residential ||
      a.alley ||
      a.avenue ||
      a.boulevard ||
      a.square ||
      a.place ||
      '';

    /*
     * BLOCK / SECTOR / PLOT
     */
    const blockSector =
      a.block ||
      a.sector ||
      a.city_block ||
      a.allotments ||
      '';

    /*
     * LOCAL AREA / COLONY / MOHALLA / SUBURB
     */
    const area =
      a.suburb ||
      a.neighbourhood ||
      a.colony ||
      a.locality ||
      a.quarter ||
      a.hamlet ||
      a.village_district ||
      a.subdistrict ||
      '';

    /*
     * CITY / TOWN / VILLAGE
     */
    const city =
      a.city ||
      a.town ||
      a.village ||
      a.municipality ||
      a.city_district ||
      '';

    /*
     * DISTRICT
     *
     * state_district is especially useful for India.
     */
    const district =
      a.state_district ||
      a.district ||
      a.county ||
      '';

    /*
     * STATE
     */
    const state =
      a.state ||
      '';

    /*
     * PIN CODE
     */
    const pincode =
      a.postcode ||
      '';

    /*
     * COUNTRY
     */
    const country =
      a.country ||
      '';

    /*
     * Build address in proper order
     */
    const components = [
      houseNumber,
      building,
      street,
      blockSector,
      area,
      city,
      district,
      state,
      pincode,
      country
    ];

    /*
     * Remove:
     * - empty values
     * - duplicates
     * - unwanted geographic values
     */
    const uniqueParts: string[] = [];

    for (const component of components) {

      if (!component) {
        continue;
      }

      const value = String(component).trim();

      if (!value) {
        continue;
      }

      // Remove unwanted broad geographic/timezone values
      const unwantedValues = [
        'Asia/Kolkata',
        'Mainland India'
      ];

      const isUnwanted =
        unwantedValues.includes(value) &&
        value !== country;

      if (isUnwanted) {
        continue;
      }

      // Case-insensitive duplicate check
      const alreadyExists = uniqueParts.some(
        x => x.toLowerCase() === value.toLowerCase()
      );

      if (!alreadyExists) {
        uniqueParts.push(value);
      }
    }

    if (uniqueParts.length <= 2 && res.display_name) {
      return res.display_name;
    }

    return uniqueParts.join(', ');
  }


  // ============================================================
  // 4. BigDataCloud Fallback
  // ============================================================
  private fallbackBigDataCloud(
    lat: number,
    lon: number,
    latLongStr: string
  ): void {

    const url =
      `https://api.bigdatacloud.net/data/reverse-geocode-client` +
      `?latitude=${encodeURIComponent(lat)}` +
      `&longitude=${encodeURIComponent(lon)}` +
      `&localityLanguage=en`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(async (response) => {

        if (!response.ok) {
          throw new Error(
            `BigDataCloud API failed: ${response.status}`
          );
        }

        return response.json();
      })
      .then((res: any) => {

        console.log(
          'BigDataCloud response:',
          res
        );

        const address = this.buildBigDataCloudAddress(res);

        if (address) {

          this.addressCache.set(
            latLongStr,
            address
          );

        } else {

          this.addressCache.set(
            latLongStr,
            latLongStr
          );
        }

        this.fetchingAddresses.delete(latLongStr);

        try {
          this.cdr.detectChanges();
        } catch (error) {
          // Ignore
        }
      })
      .catch((error) => {

        console.error(
          'BigDataCloud reverse geocoding error:',
          error
        );

        this.fetchingAddresses.delete(latLongStr);

        // Final fallback
        this.addressCache.set(
          latLongStr,
          latLongStr
        );

        try {
          this.cdr.detectChanges();
        } catch (e) {
          // Ignore
        }
      });
  }


  // ============================================================
  // 5. Build Address from BigDataCloud Response
  // ============================================================
  private buildBigDataCloudAddress(res: any): string {

    if (!res) {
      return '';
    }

    const localityInfo =
      res.localityInfo || {};

    const administrative =
      localityInfo.administrative || [];

    /*
     * Find useful administrative levels
     */
    const adminNames = administrative
      .map((item: any) => item?.name)
      .filter(Boolean);

    const components = [
      res.locality,
      res.city,
      res.principalSubdivision,
      res.postcode,
      res.countryName
    ];

    /*
     * Add useful locality information
     */
    if (adminNames.length > 0) {

      components.push(
        ...adminNames.slice(0, 3)
      );
    }

    const uniqueParts: string[] = [];

    for (const component of components) {

      if (!component) {
        continue;
      }

      const value = String(component).trim();

      if (!value) {
        continue;
      }

      const alreadyExists = uniqueParts.some(
        x => x.toLowerCase() === value.toLowerCase()
      );

      if (!alreadyExists) {
        uniqueParts.push(value);
      }
    }

    return uniqueParts.join(', ');
  }

  preFetchAddresses() {
    if (!this.trackerList || !Array.isArray(this.trackerList)) return;
    this.trackerList.forEach((item, index) => {
      setTimeout(() => {
        if (item.CheckIn_LatLong) {
          this.getAddress(item.CheckIn_LatLong);
        }
        if (item.CheckOut_LatLong) {
          this.getAddress(item.CheckOut_LatLong);
        }
      }, index * 150);
    });
  }

  onFilterChange() {
    if (this.rawResponse) {
      this.processResponse(this.rawResponse, false);
    }
  }

  processResponse(resp: any, clearAccordionState: boolean = false) {
    if (!resp) {
      resp = this.sampleData;
    }
    this.rawResponse = resp;
    let summary = resp.Item1 || [];
    let tracker = resp.Item2 || [];

    // Harvest unique employees for employee dropdown if empty
    const empMap = new Map();
    this.EmployeeList.forEach(e => empMap.set(Number(e.EmpId), e));
    summary.forEach((x: any) => {
      if (x.EmpId && !empMap.has(Number(x.EmpId))) {
        const obj = { EmpId: Number(x.EmpId), EmpName: x.Employee_Name || ('Employee ' + x.EmpId) };
        empMap.set(Number(x.EmpId), obj);
      }
    });
    this.EmployeeList = Array.from(empMap.values());

    // Multi-select Branch Filter
    if (this.SelectedBranches && this.SelectedBranches.length > 0) {
      const selectedBranchIds = this.SelectedBranches.map(b => Number(b.BranchId));
      summary = summary.filter((x: any) => selectedBranchIds.includes(Number(x.BranchId)));
    } else if (this.BranchId && Number(this.BranchId) !== 0) {
      summary = summary.filter(
        (x: any) => Number(x.BranchId) === Number(this.BranchId)
      );
    }

    // Single/Multi-select Employee Filter
    if (this.EmpId && Number(this.EmpId) !== 0) {
      summary = summary.filter((x: any) => Number(x.EmpId) === Number(this.EmpId));
    } else if (this.SelectedEmployees && this.SelectedEmployees.length > 0) {
      const selectedEmpIds = this.SelectedEmployees.map(e => Number(e.EmpId));
      summary = summary.filter((x: any) => selectedEmpIds.includes(Number(x.EmpId)));
    }

    this.summaryList = summary;
    this.trackerList = tracker;

    // Build Employee -> Branch Accordion Hierarchy
    this.buildEmployeeHierarchy(clearAccordionState);

    // Pre-fetch Reverse Geocoded Addresses
    this.preFetchAddresses();
  }

  // Unique Identifier Set State Tracking
  openEmpSet = new Set<string>();
  openBranchSet = new Set<string>();

  getEmpKey(empGroup: any, empIdx: number): string {
    if (!empGroup) return `EMP_IDX_${empIdx}`;
    const id = empGroup.EmpId != null && empGroup.EmpId !== 0 ? empGroup.EmpId : empGroup.Employee_Name;
    return `EMP_${id}`;
  }

  getBranchKey(empGroup: any, branchGroup: any, empIdx: number, branchIdx: number): string {
    const empId = empGroup && (empGroup.EmpId != null && empGroup.EmpId !== 0 ? empGroup.EmpId : empGroup.Employee_Name);
    const branchId = branchGroup && (branchGroup.BranchId != null && branchGroup.BranchId !== 0 ? branchGroup.BranchId : branchGroup.Branch_Name);
    return `BR_${empId}_${branchId}_${branchIdx}`;
  }

  buildEmployeeHierarchy(clearAccordionState: boolean = false) {
    const empMap = new Map<string, any>();

    this.summaryList.forEach((item: any) => {
      const empKey = String(item.EmpId != null && item.EmpId !== 0 ? item.EmpId : item.Employee_Name);
      if (!empMap.has(empKey)) {
        empMap.set(empKey, {
          EmpId: item.EmpId,
          Employee_Name: item.Employee_Name || 'Unknown Employee',
          Total_Count: 0,
          branches: []
        });
      }
      const empGroup = empMap.get(empKey)!;

      const branchObj = {
        BranchId: item.BranchId,
        Branch_Name: item.Branch_Name || 'Unknown Branch',
        Total_Count: item.Total_Count || 0,
        parentSummary: item
      };
      empGroup.branches.push(branchObj);
      empGroup.Total_Count += branchObj.Total_Count;
    });

    this.groupedEmployeeList = Array.from(empMap.values());
    if (clearAccordionState) {
      this.openEmpSet.clear();
      this.openBranchSet.clear();
    }
  }

  isEmpOpen(empGroup: any, empIdx: number): boolean {
    const key = this.getEmpKey(empGroup, empIdx);
    return this.openEmpSet.has(key);
  }

  isBranchOpen(empGroup: any, branchGroup: any, empIdx: number, branchIdx: number): boolean {
    const key = this.getBranchKey(empGroup, branchGroup, empIdx, branchIdx);
    return this.openBranchSet.has(key);
  }

  toggleEmp(empGroup: any, empIdx: number, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const key = this.getEmpKey(empGroup, empIdx);
    if (this.openEmpSet.has(key)) {
      this.openEmpSet.delete(key);
    } else {
      this.openEmpSet.add(key);
    }
    try { this.cdr.detectChanges(); } catch (e) {}
  }

  toggleBranchNode(empGroup: any, branchGroup: any, empIdx: number, branchIdx: number, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const key = this.getBranchKey(empGroup, branchGroup, empIdx, branchIdx);
    if (this.openBranchSet.has(key)) {
      this.openBranchSet.delete(key);
    } else {
      this.openBranchSet.add(key);
    }
    try { this.cdr.detectChanges(); } catch (e) {}
  }

  expandAll() {
    this.openEmpSet.clear();
    this.openBranchSet.clear();
    this.groupedEmployeeList.forEach((empGroup, empIdx) => {
      const empKey = this.getEmpKey(empGroup, empIdx);
      this.openEmpSet.add(empKey);
      if (empGroup.branches) {
        empGroup.branches.forEach((branchGroup, branchIdx) => {
          const branchKey = this.getBranchKey(empGroup, branchGroup, empIdx, branchIdx);
          this.openBranchSet.add(branchKey);
        });
      }
    });
    try { this.cdr.detectChanges(); } catch (e) {}
  }

  collapseAll() {
    this.openEmpSet.clear();
    this.openBranchSet.clear();
    try { this.cdr.detectChanges(); } catch (e) {}
  }

  trackByEmp(index: number, item: any): any {
    return item.EmpId != null && item.EmpId !== 0 ? item.EmpId : (item.Employee_Name || index);
  }

  trackByBranch(index: number, item: any): any {
    return item.BranchId != null && item.BranchId !== 0 ? item.BranchId : (item.Branch_Name || index);
  }

  trackByChild(index: number, item: any): any {
    return item.Loan_Number || item.Application_No || item.Borrower_Name || index;
  }

  getTrackerDetailsForParent(parent: any): any[] {
    if (!parent) return [];

    // Filter child items for the specific Employee first
    const empTrackerList = this.trackerList.filter(
      (x) => Number(x.EmpId) === Number(parent.EmpId)
    );

    let list: any[] = [];

    // Check if child items explicitly contain BranchId
    const hasBranchId = empTrackerList.some((x) => x.BranchId != null);

    if (hasBranchId) {
      list = empTrackerList.filter(
        (x) => Number(x.BranchId) === Number(parent.BranchId)
      );
    } else {
      // If child items lack BranchId, partition items according to the branch summary Total_Count
      const empBranches = this.summaryList.filter(
        (s) => Number(s.EmpId) === Number(parent.EmpId)
      );
      const branchIdx = empBranches.findIndex(
        (b) => Number(b.BranchId) === Number(parent.BranchId)
      );

      if (branchIdx !== -1) {
        let startIndex = 0;
        for (let k = 0; k < branchIdx; k++) {
          startIndex += Number(empBranches[k].Total_Count || 0);
        }
        const count = Number(parent.Total_Count || 0);
        list = empTrackerList.slice(startIndex, startIndex + count);
      } else {
        list = empTrackerList;
      }
    }

    if (this.SearchText && this.SearchText.trim()) {
      const txt = this.SearchText.toLowerCase().trim();
      list = list.filter(
        (item) =>
          (item.Borrower_Name && item.Borrower_Name.toLowerCase().includes(txt)) ||
          (item.Loan_Number && item.Loan_Number.toLowerCase().includes(txt)) ||
          (item.Application_No && item.Application_No.toLowerCase().includes(txt)) ||
          (item.CheckIn_Remark && item.CheckIn_Remark.toLowerCase().includes(txt)) ||
          (item.CheckOut_Remark && item.CheckOut_Remark.toLowerCase().includes(txt))
      );
    }
    return list;
  }

  resetFilters() {
    this.BranchId = 0;
    this.EmpId = 0;
    this.SelectedBranches = [];
    this.SelectedEmployees = [];
    this.DateFrom = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    this.DateTo = new Date();
    this.SearchText = "";
    this.getBranchesList();
    this.getCollectionTrackerReport();
  }

  openImageModal(imgName: string, applicationNo: string, title: string) {
    if (!imgName || !applicationNo) return;
    this.selectedImageTitle = `${title} - ${applicationNo}`;
    this.selectedImageSrc = this.docBaseUrl + applicationNo + "/" + imgName;
  }

  closeImageModal() {
    this.selectedImageSrc = null;
  }

  getTotalVisitsCount(): number {
    if (!this.summaryList || this.summaryList.length === 0) return 0;
    return this.summaryList.reduce((acc, cur) => acc + (Number(cur.Total_Count) || 0), 0);
  }

  getUniqueBranchesCount(): number {
    if (!this.summaryList || this.summaryList.length === 0) return 0;
    const branches = new Set(this.summaryList.map((x) => x.BranchId));
    return branches.size;
  }

  getUniqueEmployeesCount(): number {
    if (!this.summaryList || this.summaryList.length === 0) return 0;
    const emps = new Set(this.summaryList.map((x) => x.EmpId || x.Employee_Name));
    return emps.size;
  }

  exportToExcel() {
    let exportData: any[] = [];
    this.summaryList.forEach((parent) => {
      const children = this.getTrackerDetailsForParent(parent);
      if (children.length > 0) {
        children.forEach((child) => {
          exportData.push({
            "Employee Name": parent.Employee_Name,
            "Branch Name": parent.Branch_Name,
            "Borrower Name": child.Borrower_Name || "-",
            "Loan Number": child.Loan_Number || "-",
            "Application No": child.Application_No || "-",
            "Check-In Time": child.CheckIn_On ? this.formatDateTime(child.CheckIn_On) : "-",
            "Check-In Remark": child.CheckIn_Remark || "-",
            "Check-In Lat/Long": child.CheckIn_LatLong || "-",
            "Check-Out Time": child.CheckOut_On ? this.formatDateTime(child.CheckOut_On) : "-",
            "Check-Out Remark": child.CheckOut_Remark || "-",
            "Check-Out Lat/Long": child.CheckOut_LatLong || "-",
            "Total Time Taken": child.Total_Time_Taken || "-"
          });
        });
      } else {
        exportData.push({
          "Employee Name": parent.Employee_Name,
          "Branch Name": parent.Branch_Name,
          "Borrower Name": "-",
          "Loan Number": "-",
          "Application No": "-",
          "Check-In Time": "-",
          "Check-In Remark": "-",
          "Check-In Lat/Long": "-",
          "Check-Out Time": "-",
          "Check-Out Remark": "-",
          "Check-Out Lat/Long": "-",
          "Total Time Taken": "-"
        });
      }
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, `Collection_Tracker_Accordion_Report_${new Date().getTime()}${EXCEL_EXTENSION}`);
  }

  private formatDate(date: any): string {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  formatDateTime(dateStr: any): string {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
}
